import { observable } from "mobx";
import { api, apiOperacao } from "../../api";
import { toast } from "react-toastify";
import { decodeUtf8String, downloadBinaryFile, toast_error } from "../../utils";

export class _LegislacaoStore {

  obs = observable({
    loading: false
  })

  async get_pdf(modelo: string) {

    try {

      this.obs.loading = true

      let resp = await apiOperacao("legislacoes").get(`/legislacoes/legislacao/${modelo}`, {
        responseType: 'arraybuffer'
      });

      let fileName = ""

      if (modelo == "icms") {

        fileName = "ModelodeCalculoICMSANTECIPADO-Abril-2020.pdf"

      } else {

        fileName = "dc2023_02931.pdf"

      }

      if (resp.status == 200) {

        downloadBinaryFile(resp.data, fileName);

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao carregar documento, tente novamente mais tarde.`);

    }

    this.obs.loading = false

  }

}

export const LegislacaoStore = new _LegislacaoStore();
